import { http } from "../http";

export interface getUserInfo{
    customerName: string;
    customerLastName: string;
    customerAtaAdi: string;
    lang:string;
    userName: string;
    phoneNumber: string;
    TOTPEnabled: string;
    TOTPChangeDate: string;
    email?: string;
}

export const getLoggedUserInfo = async (): Promise<getUserInfo[]> => {
    const { data } = await http.get<getUserInfo[]>(`auth/getuserinfo`);
    return data;
};
